export default __webpack_public_path__ + "static/media/1. dashboard.d9d4a84e.png";